export const PencilIcon = () => {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10.5" cy="10.5" r="10.5" fill="url(#paint0_linear_14_33)" />
            <path
                d="M7.21124 11.1563C7.15464 11.2132 7.11783 11.2868 7.10624 11.3663L6.75374 13.8225C6.74504 13.8802 6.75 13.9391 6.76822 13.9944C6.78644 14.0498 6.81741 14.1001 6.85864 14.1414C6.89986 14.1826 6.95019 14.2136 7.00557 14.2318C7.06095 14.25 7.11984 14.255 7.17749 14.2463L9.63374 13.8938C9.71318 13.8822 9.78679 13.8454 9.84374 13.7888L12.7387 10.8975L10.1025 8.26502L7.21124 11.1563Z"
                fill="#4088DD"
            />
            <path
                d="M11.07 7.29752L10.635 7.73252L13.2675 10.365L13.7062 9.93002C15.4436 8.18365 12.8086 5.55895 11.07 7.29752Z"
                fill="#4088DD"
            />
            <defs>
                <linearGradient id="paint0_linear_14_33" x1="0" y1="0" x2="21" y2="21" gradientUnits="userSpaceOnUse">
                    <stop offset="0.114583" stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.5" />
                </linearGradient>
            </defs>
        </svg>
    );
};
